class MapboxGlNotSupportedError extends Error {
  constructor(message: string, ...args: unknown[]) {
    // @ts-expect-error
    super(message, ...args);
    this.message = 'Mapbox GL is not supported';
  }
}

export default MapboxGlNotSupportedError;
